import React from "react";

export const BtnGroup = ({ children, isThree }) => {
  return <div className={`mobile-btn-group ${isThree && "mobile-btn-group-three"}`}>{children}</div>;
};
